<template>
  <div>
    <el-card>
      <!-- 搜索 添加 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="操作者">
          <el-select
            v-model="queryParams.userId"
            placeholder="请下拉选择操作者"
            size="small"
            clearable
          >
            <el-option v-for="user in userList"
                       :key="user.userId"
                       :value="user.userId"
                       :label="user.userName">
              {{ user.userName }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select
            v-model="queryParams.opType"
            placeholder="请下拉选择操作类型"
            size="small"
            clearable
          >
            <el-option v-for="dic in opTypeDicList"
                       :key="dic.codeValue"
                       :value="dic.codeValue"
                       :label="dic.codeName">
              {{ dic.codeName }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成功标识">
          <el-select
            v-model="queryParams.successFlag"
            placeholder="请选择操作成功与否"
            size="small"
            clearable
          >
            <el-option value="1" label="成功"></el-option>
            <el-option value="0" label="失败"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作来源">
          <el-select
            v-model="queryParams.channel"
            placeholder="请选择操作来源"
            size="small"
            clearable
          >
          <el-option value="1" label="通过网页"></el-option>
          <el-option value="2" label="通过App"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="selectTimeFunc"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="warning" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 用户列表区域 -->
      <el-table :data="logList" border stripe>
        <el-table-column prop="id" label="id" v-if="false"></el-table-column>
        <el-table-column prop="logTime" label="记录时间"></el-table-column>
        <el-table-column prop="userId" label="操作者" :formatter="userIdFormatter"></el-table-column>
        <el-table-column prop="opType" label="操作类型" ></el-table-column>
        <el-table-column prop="opContent" label="详细内容"></el-table-column>
        <el-table-column prop="successFlag" label="成功标识" :formatter="successFlagFormatter"></el-table-column>
        <el-table-column prop="channel" label="操作来源" :formatter="channelFormatter"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

  </div>
</template>

<script>
import { checkLogin } from '@/api/globalProcessErr'
import {listSysLog} from "@/api/sysLog";
import {listUser} from "@/api/sysUser";
import {listCodeByClass} from "@/api/code";
import {parseTime} from "@/api/util";

export default {
  data () {
    return {
      queryParams: {
        opType: undefined,
        successFlag: undefined,
        channel: undefined,
        userId: undefined,
        startTime: '',
        endTime: '',
        // 当前页数
        pageNum: 1,
        // 每页显示多少数据
        pageSize: 20
      },
      timeRange: [
        new Date((new Date()) - 30 * 24 * 60 * 60 * 1000),
        new Date()
      ],
      opTypeDicList: [],
      logList: [],
      userList: [],
      total: 0,
      minTime: undefined,
      maxTime: undefined,
      // pickerOptions: {
      //   onPick (time) {
      //     // 如果选择了只选择了一个时间
      //     if (!time.maxDate) {
      //       let timeRange = 24 * 60 * 60 * 1000 // 6天
      //       this.minTime = time.minDate.getTime() - timeRange // 最小时间
      //       this.maxTime = time.minDate.getTime() + timeRange // 最大时间
      //       // 如果选了两个时间，那就清空本次范围判断数据，以备重选
      //     } else {
      //       this.minTime = this.maxTime = null
      //     }
      //   },
      //   disabledDate (time) {
      //     // onPick后触发
      //     // 该方法会轮询当3个月内的每一个日期，返回false表示该日期禁选
      //     if (this.minTime && this.maxTime) {
      //       return time.getTime() < this.minTime || time.getTime() > this.maxTime
      //     }
      //   }
      // }
    }
  },
  computed: {

  },
  created () {
    this.$i18n.locale = window.sessionStorage.getItem('lang')

  },
  mounted() {
    this.getUserList()
    this.getOpTypeCode()
    this.getLogList()
  },
  methods: {
    getLogList () {
      const req = this.queryParams
      listSysLog(req).then(res => {
        checkLogin(res)
        const code = res.data.code
        if (code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.logList = res.data.data.list
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    getUserList(){
      const req = {
        pageNum: 1,
        pageSize: 100000
      }
      listUser(req).then(res => {
        checkLogin(res)
        const code = res.data.code
        if (code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.userList = res.data.data.list
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    getOpTypeCode(){
      let self = this
      listCodeByClass('OP_TYPE').then(res =>{
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.opTypeDicList = res.data.data
      })
    },
    // 监听 pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryParams.pageSize = newSize
      this.getLogList()
    },
    // 监听 页码值 改变事件
    handleCurrentChange (newSize) {
      this.queryParams.pageNum = newSize
      this.getLogList()
    },
    userIdFormatter(row,column){
      for(let i=0;i<this.userList.length;i++){
        if (row.userId === this.userList[i].userId){
          return this.userList[i].userName
        }
      }
    },
    successFlagFormatter (row, column) {
      if (row.successFlag === 1) {
        return '成功'
      } else {
        return '失败'
      }
    },
    selectTimeFunc(){
      if (this.timeRange === undefined || this.timeRange === null
        || this.timeRange[0] === undefined || this.timeRange[0] === null
        || this.timeRange[1] === undefined || this.timeRange[1] === null){
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        return
      }
      this.queryParams.startTime = parseTime(this.timeRange[0], '{y}-{m}-{d} 00:00:00')
      this.queryParams.endTime = parseTime(this.timeRange[1], '{y}-{m}-{d} 23:59:59')
    },
    channelFormatter(row, column) {
      if (row.channel === 1) {
        return '通过网页'
      } else {
        return '通过App'
      }
    },
    search() {
      this.getLogList()
    },
    resetSearch () {
      this.queryParams = {

      }
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 20
      this.getLogList()
    },
  }
}
</script>

<style lang="less" scoped>
.myButton {

}
</style>
